import styled from 'styled-components/macro'

import { colors } from 'styled/theme.styled'

export const Root = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .rc-scrollbars-thumb.rc-scrollbars-thumb-h {
    background-color: ${colors.faintBlue} !important;
  }
`

export const Products = styled.div`
  width: 100%;
  height: ${({ isShort }) => (isShort ? 80 : 190)}px;
  padding-bottom: 8px;

  .Inner {
    width: auto;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 20px 12px;
    pointer-events:auto;

    @media only screen and (max-width: 767px) {
      justify-content: flex-start;
    }
  }
`

export const ProductBox = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: 90px;
  height: 100%;
  border-bottom: 1px solid ${({ selected }) => (selected ? colors.darkBlue : colors.faintBlue)};

  > .Inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding: 0 8px 8px;
    transition: all 0.3s;

    > .ProductModel {
      position: relative;
      width: 100%;
      height: 80px;
      margin-bottom: 12px;
      pointer-events: none;

      > svg {
        position: absolute;
        width: 100%;
        height: 100%;
        transform: scale(${({ selected }) => (selected ? 1.2 : 1)});
        transform-origin: bottom;
        transition: transform 0.3s;

        * {
          stroke-width: 4px;
          stroke: ${({ selected }) => (selected ? colors.darkBlue : colors.midGrey)};
          transition: stroke 0.3s;
        }
      }
    }
    > .Year {
      font-size: 14px;
      text-align: center;
      white-space: nowrap;
      color: ${colors.darkBlue};
      opacity: 0.25;
      overflow: hidden;
      max-height: ${({ selected }) => (selected ? 0 : 50)}px;
      transition: max-height 0.35s;
    }

    > .Name {
      font-size: 14px;
      text-align: center;
      font-weight: bold;
      line-height: 1.5;
      color: ${colors.darkBlue};
      overflow: hidden;
      max-height: ${({ selected }) => (selected ? 50 : 0)}px;
      transition: max-height 0.35s;
    }
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      > .Inner {
        > .Year {
          max-height: 0px;
        }

        > .Name {
          max-height: 50px;
        }

        > .ProductModel {
          svg {
            transform: scale(1.2);
          }
        }
      }
    }
  }
`

export const GroupButton = styled.div`
  padding: 16px;
  border-radius: 999px;
  background-color: ${colors.faintBlue};
  color: ${colors.darkBlue};
  font-size: 12px;
  text-transform: uppercase;
  user-select: none;

  &:hover {
    cursor: pointer;
  }
`
